
export default {
    main:{
        home: '首页',
        guided_tour: '智能导览',
        menber: '会员',
        my: '我的',

        overview: '概况',
        serve: '服务',
        reality: '实景',
        map: '地图',
        facilities: '设施',
        audio: '讲解',
        search: '查找',
        my_position: '我的位置',
        recommended_routes: '推荐路线',
        play_route: '游玩路线',
        go_here: '去这里',
        listen_on_go: '边走边听',

        spots_search_placeholder: '请输入你要搜索的景点、公共设施',
        spots_detail: '景点详情',
        whole: '全部',
        hours: '小时',
        check: '查看',
        hide: '隐藏',
        recommend: '推荐',

        '个景点': ' 个景点',
        '公里': '公里',
        '小时': ' 小时',
        '上划查看路线介绍': '上划查看路线介绍',
        '去这里': '去这里',
        '选择语言': '选择语言',
        '营业时间': '营业时间',
        '地址': '地址',
        '电话': '电话',
        '详情': '详情',
        '语音讲解': '语音讲解',
        '暂停': '暂停',
        '继续': '继续',
        '到这里去': '到这里去',
        '视频讲解': '视频讲解',
        '距您': '距您',
        '走到景点附近自动播放语音讲解': '走到景点附近自动播放语音讲解',
        '关闭边走边听': '关闭边走边听',
        '浏览器阻止了定位操作！': '浏览器阻止了定位操作！',
        '无法获得当前位置！': '无法获得当前位置！',
        '定位超时！': '定位超时！',
        '没有找到相关数据哦！': '没有找到相关数据哦！',
        '查看详情': '查看详情',
        '请开启蓝牙服务以便使用边走边听': '请开启蓝牙服务以便使用边走边听',
        '请开启位置服务以便使用边走边听': '请开启位置服务以便使用边走边听',
        '系统或设备不支持蓝牙定位': '系统或设备不支持蓝牙定位',
        '系统错误': '系统错误',

        '当前不在景区范围内！': '当前不在景区范围内！',

        '步行': '步行',
        '开车': '开车',
        '坐船': '坐船',
        '骑行': '骑行',

        '景点设施': '景点设施',
        '返回': '返回',
        '展开查看': '展开查看',
        '收起': '收起',
        '路线介绍': '路线介绍',
        '查看地图': '查看地图',
        '路线详情': '路线详情',

        '室内': '室内',
        'AR导航': 'AR导航',
    }
}